import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5438_9946)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9684 24.2419C15.4924 24.2419 18.6626 22.7309 20.863 20.323L20.2775 19.6786C19.5529 18.881 18.3177 18.8128 17.5088 19.5258L16.2598 20.6268C14.5607 22.1246 11.978 22.0301 10.394 20.4123L9.61301 19.6146C8.86306 18.8486 7.63421 18.822 6.85133 19.5547L4.56058 21.6984C6.60279 23.2921 9.17436 24.2419 11.9684 24.2419ZM21.9702 18.1573L22.2545 18.4703C23.3621 16.6547 24 14.5227 24 12.2419C24 9.47648 23.0621 6.92949 21.4861 4.90017C21.1932 4.97507 20.9132 5.11841 20.6714 5.33156L19.4224 6.43251C17.7233 7.93033 15.1406 7.83592 13.5566 6.21806L12.7756 5.42041C12.0256 4.65445 10.7968 4.62775 10.0139 5.3604L6.80042 8.36779L5.23708 6.71536L8.45058 3.70796C10.1399 2.12696 12.7917 2.18458 14.41 3.83746L15.1909 4.63511C15.9251 5.38484 17.1219 5.42859 17.9093 4.73448L19.1582 3.63353C19.3679 3.44876 19.5907 3.28832 19.8234 3.15197C17.7156 1.33852 14.9704 0.241943 11.9684 0.241943C5.93258 0.241943 0.934849 4.67474 0.0693464 10.4543C1.71636 9.50871 3.85491 9.75592 5.23829 11.1688L6.14147 12.0913C6.84349 12.8084 7.97595 12.884 8.76806 12.2667L11.4454 10.1805C13.0524 8.92838 15.3274 8.98895 16.8647 10.3248L20.5103 13.4928L19.0094 15.2014L15.3637 12.0335C14.6513 11.4144 13.597 11.3863 12.8524 11.9667L10.175 14.0529C8.46568 15.3848 6.02196 15.2215 4.50707 13.6743L3.6039 12.7518C2.85394 11.9859 1.62509 11.9591 0.842217 12.6918L0 13.48C0.260464 16.0146 1.31188 18.3155 2.90401 20.1333L5.288 17.9022C6.97736 16.3212 9.62909 16.3788 11.2474 18.0317L12.0284 18.8293C12.7625 19.579 13.9593 19.6229 14.7467 18.9288L15.9957 17.8278C17.741 16.2892 20.4066 16.4363 21.9702 18.1573Z"
        fill="url(#paint0_linear_5438_9946)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5438_9946"
        x1="12"
        y1="0.241944"
        x2="16.7179"
        y2="24.242"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#780000" />
        <stop offset="1" stop-color="#C1121F" />
      </linearGradient>
      <clipPath id="clip0_5438_9946">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.241943)"
        />
      </clipPath>
    </defs>
  </svg>
)
